import script from "./UiDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDialog.vue?vue&type=script&setup=true&lang=js"

import "./UiDialog.vue?vue&type=style&index=0&id=6761f238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6761f238"]])

export default __exports__